document.addEventListener("DOMContentLoaded", function (){

    // Helper Variables
    var dbug = document.cookie.match(new RegExp('(^| )' + "dbug" + '=([^;]+)')) ? true : false;
    var observerOptions = { rootMargin: '0px', threshold: [0, 0.25, 0.5, 0.75, 1] };
    var intersectionRatioLimit = 0.35;
    var isMobile = io.windowWidth() >= 1024 ? false : true;

    // Col2 Images
    var observerCol2Images = new IntersectionObserver(function(entries){
        var timeline = entries[0].target.timeline; // AnimeJS Timeline
        var targetBiggerThanViewport = io.height(entries[0].target) >= io.windowHeight() ? true : false;

        // Debugging Messages
        if(dbug) {
            console.groupCollapsed("observer effects & variables");
            console.log("isIntersecting", entries[0].isIntersecting);
            console.log("timeline.reversed", timeline.reversed);
            console.log("timeline.completed", timeline.completed);
            console.log("timeline", timeline);
            console.log("entries[0]", entries[0]);
            console.groupEnd();
        }

        // Timeline - Start/Play Timeline Animation
        if((entries[0].isIntersecting && entries[0].intersectionRatio >= intersectionRatioLimit) || targetBiggerThanViewport){
            timeline.play();
            io.addClass(entries[0].target, "-observed");
            observerCol2Images.unobserve(entries[0].target);
        }
    }, observerOptions);

    io.elementsEach(".frame-layout-col-2-images-text-top-right, .frame-layout-col-2-images-text-top", function(el){
        var imageContainer = el.querySelectorAll(".image-left, .image-right"),
            text = el.querySelector(".text"),
            icon = el.querySelector(".icon-bubble"),
            timelineSpeedDefault = 2000,
            timelineSpeedText = 750,
            timelineSpeedIcon = 1000,
            timeline = anime.timeline({
                easing: 'cubicBezier(0, 0.355, 0.180, 1.475)',
                duration: timelineSpeedDefault,
                loop: false,
                autoplay: false
            });

        // Timeline - Images
        imageContainer.forEach(function(img) {
            var offsetX = img.classList.contains("image-right") ? 300 : -300,
                offsetY = offsetX / 2,
                image = img.querySelectorAll(".image").length ? img.querySelector(".image") : img;

            image.style = "opacity: 0"; // Starts with opacity 0 before any effects can happen
            timeline.add({
                targets: image,
                keyframes: [
                    { translateX: offsetX, translateY: offsetY, opacity: 0, duration: 0 },
                    { translateX: 0, translateY: 0, opacity: 1 }
                ]
            }, 0);
        });

        // Timeline - Header / Text
        var textOffsetX = text.classList.contains("text-right") ? 300 : -300,
            textElements = [text.querySelector("header h4"), text.querySelector("header h3"), text.querySelector("p")];

        timeline.add({
            targets: textElements,
            keyframes: [
                { translateX: textOffsetX, opacity:0, duration: 0 },
                { translateX: 0, opacity:1, duration:timelineSpeedText }
            ],
            delay: anime.stagger(75)
        }, "-=250");

        // Timeline - Icon
        var iconOffsetX = 0;
        if(icon) {
            var iconOffsetX = icon.classList.contains("icon-right") ? 300 : -300;
            icon.style="opacity:0";
        }

        // AnimeJS - SlideIntoView Effect
        // (see also: https://animejs.com/documentation/#animationKeyframes)
        // (https://www.sitepoint.com/get-started-anime-js/)
        // (https://matthewlein.com/tools/ceaser)
        timeline.add({
            targets: icon,
            keyframes: [
                { translateX: iconOffsetX, opacity:0, duration: 0 },
                { translateX: 0, "rotate":"180deg", opacity:1, duration:timelineSpeedIcon },
                { "rotate":"0deg", duration:500 }
            ],
            easing: "easeOutSine"
        }, "-=500");

        // Create "timeline" Reference on Element (for later use in the Observer)
        el.timeline = timeline;

        // Add Element to Observer
        // (in this case the onload event is extremely important, while images, etc. are beeing loaded,
        // because the scroll position and the intersection of elements are not up to date with each
        // other on Dom-Ready, therefore there is no guarantee that the intersection will trigger
        // => seems like a browser bug or a intentional behavior?!)
        window.addEventListener("load", function(){
            if(elementInViewport(el)){
                // Make sure the animation is played, due to the observer problems (if the element is higher than the viewport itself)
                io.addClass(el, "-observed");
                timeline.play();
            } else {
                // Apply Observer to Element
                observerCol2Images.observe(el);
            }
        });
    });

    // Col3 Images Zoom
    io.elementsEach(".image-3col-zoom", function(el) {
        var sliderButtons = el.querySelectorAll(".slider-button");
        var sliderSlides = el.querySelectorAll(".slider-slide");
        var sliderImages = el.querySelectorAll(".slider-slide .image-embed-item img");
        var sliderCaptions = el.querySelectorAll(".slider-slide figcaption");

        slideEffect(); // Set Slide Effect Defaults

        io.on(sliderButtons, "click", function(e) {
            slideEffect();
        });

        function slideEffect() {
            io.elementsEach(sliderSlides, function(el){ io.removeClass(el, "-active"); });
            io.elementsEach(el.querySelectorAll(".slider-slide.tns-slide-active"), function(slide, index) {
                if(index == 1) {
                    io.addClass(slide, "-active");
                }
            });
        }
    });

    // Col2 Fade Bottom - Pagination Numbers
    // https://trello.com/c/On9vQQ3y/
    // ".frame-layout-image-2col-fade-topbottom .slider-wrapper"
    sliderPagination(".frame-layout-image-2col-fade-topbottom .slider-wrapper", ".slider-slide.tns-normal", ".slider-button");

    function sliderPagination(sliderWrapperSelector, sliderElementsSelector, sliderButtonSelector, sliderStepsNum){
        var sliderSteps = sliderStepsNum ? sliderStepsNum : 1;

        io.elementsEach(sliderWrapperSelector, function(sliderWrapper) {
            var sliderElements = sliderWrapper.querySelectorAll(sliderElementsSelector);

            // Create the Pagination Element and Events (as long as enough elements/images exist for the slide animation)
            if(sliderElements.length > 1) {
                var sliderPaginationMax = sliderElements.length / sliderSteps;
                var sliderPagination = io.prependTo("div", sliderWrapper, { "class":"slider-pagination" });
                var sliderPaginationIndex = 1;

                sliderPagination.textContent = "01 / 0" + sliderPaginationMax;

                io.on(sliderWrapper.querySelector(sliderButtonSelector+sliderButtonSelector+"-prev"), "click", function(e) {
                    sliderPaginationIndex = sliderPaginationIndex <= 1 ? sliderPaginationMax : sliderPaginationIndex - 1;
                    sliderPagination.textContent = "0" + sliderPaginationIndex + " / 0" + sliderPaginationMax;
                });

                io.on(sliderWrapper.querySelector(sliderButtonSelector+sliderButtonSelector+"-next"), "click", function(e) {
                    sliderPaginationIndex = sliderPaginationIndex >= sliderPaginationMax ? 1 : sliderPaginationIndex + 1;
                    sliderPagination.textContent = "0" + sliderPaginationIndex + " / 0" + sliderPaginationMax;
                });
            } else {
                // Hide slider buttons if not enough elements exist for a slide animation
                io.elementsEach(sliderWrapper.querySelectorAll(sliderButtonSelector), function(sliderButton) {
                    io.addClass(sliderButton, "-hidden");
                });
            }
        });
    }

    // Layout Gallery Diagonal
    // https://trello.com/c/zVNCPm2y/
    var observerGalleryDiagonal = new IntersectionObserver(function(entries){
        var entry = entries[0].target;

        if(entries[0].isIntersecting && entries[0].intersectionRatio >= intersectionRatioLimit){
            io.addClass(entry, "-observed");
            observerGalleryDiagonal.unobserve(entry);
        }
    }, observerOptions);

    io.elementsEach(".frame-layout-galleryDiagonal", function(gallery) {
        var cols = gallery.querySelectorAll(".ce-column");
        var btnPrev = gallery.querySelector(".gallery-controls-btn-prev");
        var btnNext = gallery.querySelector(".gallery-controls-btn-next");
        var slideSteps = isMobile ? 1 : 3; // 3 Columns/Slides on Desktop, 1 Column/Slide on Mobile
        var slideIndex = isMobile ? 1 : 0; // Start with the second slide on mobile (1 Column) (Ticket: https://trello.com/c/UB8iXv9F/)

        window.addEventListener("load", function(){
            // Check if gallery is in viewport, otherwise observe the gallery until it intersects
            if(elementInViewport(gallery)){
                io.addClass(gallery, "-observed");
                io.addClass(gallery.querySelector("header"), "-observed");
                io.addClass(gallery.querySelector(".ce-bodytext"), "-observed");
                io.addClass(gallery.querySelector(".ce-gallery"), "-observed");
            } else {
                observerGalleryDiagonal.observe(gallery);
                observerGalleryDiagonal.observe(gallery.querySelector("header"));
                observerGalleryDiagonal.observe(gallery.querySelector(".ce-bodytext"));
                observerGalleryDiagonal.observe(gallery.querySelector(".ce-gallery"));
            }
        });

        // Init Defaults
        io.elementsEach(cols, function(col, colIndex) {
            var link = col.querySelector(".image-container a");
            var caption = col.querySelector(".image-caption");

            if(link && caption){
                var captionLink = document.createElement("a");
                var captionLinkWrapper = document.createElement("div");

                io.appendTo(captionLinkWrapper, caption, { "class":"image-caption-link btn-with-line" });
                io.appendTo(captionLink, captionLinkWrapper, { "href":link.href });

                captionLink.textContent = link.title ? link.title : "Mehr lesen..";
            }

            io.addClass(col, "-element");
            io.addClass(col, "-element-" + (colIndex % slideSteps));

            if(colIndex <= slideSteps - 1){
                io.addClass(col, "-active");
                io.addClass(col, "-active-" + colIndex);
            }

            // Mobile (1 Column) - Set Second Slide Element as the main active one (Ticket: https://trello.com/c/UB8iXv9F/)
            if(slideSteps == 1){
                if(colIndex == 1){
                    io.addClass(col, "-active");
                    io.addClass(col, "-active-0");
                } else {
                    io.removeClass(col, "-active");
                    io.removeClass(col, "-active-0");
                }
            }
        });

        // Controls - Button Next
        io.on(btnNext, "click", function(e) {
            rotateSlide("next");
        });

        // Controls Button Prev
        io.on(btnPrev, "click", function(e) {
            rotateSlide("prev");
        });

        function rotateSlide(slideDirection){
            var slideRangeIndex = 0;
            io.addClass(gallery, "-user-sliding");

            // Reset slideIndex if it's at the end, otherwise increase the slideIndex by one
            if(slideDirection == "prev" || slideDirection == -1){
                slideIndex = slideIndex - slideSteps < 0 ? cols.length - slideSteps : slideIndex - slideSteps;
            } else {
                slideIndex = slideIndex + slideSteps > cols.length - slideSteps ? 0 : slideIndex + slideSteps;
            }

            // Reset active classes
            resetClasses();

            // Set new active classes
            io.elementsEach(cols, function(col, colIndex) {
                if(colIndex >= slideIndex && colIndex < slideIndex + slideSteps) {
                    io.addClass(col, "-active");
                    io.addClass(col, "-active-" + slideRangeIndex);
                    slideRangeIndex++;
                }
            });
        }

        function resetClasses(){
            io.elementsEach(cols, function(col, colIndex) {
                io.removeClass(col, "-active");

                for(var i=0; i<slideSteps; i++){
                    io.removeClass(col, "-active-" + i);
                }
            });
        }
    });

    sliderPagination(".frame-layout-galleryDiagonal .ce-gallery-inner", ".ce-column", ".gallery-controls-btn", isMobile ? 1 : 3);

    // Hide p:empty elements (js implementation, due to limited css browser implementation)
    io.elementsEach("div > p:last-of-type", function (el) {
        if (el.innerHTML == "" || el.innerHTML == " " || el.innerHTML == "&nbsp;") {
            io.addClass(el, "empty");
        }
    });

    // Teisi Stuff.. TODO: Where are some comments?!
    var description = document.querySelector('#header .image-description');
    var sliders = document.querySelectorAll("#banner [data-slider]");
    if (sliders) {
        sliders.forEach(slider => { // TODO: @Teisi THIS IS NOT IE11 Compatible!! Use ECMAScript 5, BabelJS or the IO Framework instead
            var id = slider.id;
            var firstSlideItem = document.querySelector("#" + id + "-item0");
            var imageDescription = firstSlideItem.querySelector('figcaption').innerHTML;
            if (imageDescription) {
                description.innerHTML = imageDescription;
            }
        });
    }

    var imageCaption = document.querySelector("#banner div:not([data-slider]) figcaption");
    if (imageCaption) {
        var imageCaptionDescription = imageCaption.innerHTML;
        if (imageCaptionDescription) {
            description.innerHTML = imageCaptionDescription;
        }
    }
});

// START: Back to top button - speed in ms
// TODO: @Teisi Please replace your jQuery Code by native means (or through the IO Framework)
;(function($, root, window, document) { // Alias Technique
    $(function() { // Equal to $(document).ready()
        var speed = 2000;
        var backToTop = $("#backToTop");
        $(window).on("scroll", function () {
            if ($(this).scrollTop() > 200) {
                backToTop.fadeIn(100);
            } else {
                backToTop.fadeOut(0);
            }
        });
        backToTop.on("click", function () {
            $("html, body").animate({
                scrollTop: 0
            }, { duration: speed });
        });
    });
})(jQuery, this, window, document);
// END: Back to top button
